import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { StringUtilsService } from '../../../../../../core/services/string-utils.service';
import { AppState } from '../../../../../../core/reducers';
import { BehaviorSubject, Observable } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RelationshipCategory } from '../../../../../../core/lists';
import { RelationshipCategoryService } from '../../../../../../core/lists/_services/relationship-category.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-relationship-category-edit',
  templateUrl: './relationship-category-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RelationshipCategoryEditComponent implements OnInit, OnDestroy {
  companyId: number;
  loadingSubject = new BehaviorSubject<boolean>(true);
  loading$: Observable<boolean>;
  relationshipCategoryForm: FormGroup;
  hasFormErrors = false;
  submissionErrorObj: any;
  hasSubmissionErrors: boolean;
  subscriptions = [];

  constructor(
    public dialogRef: MatDialogRef<RelationshipCategoryEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<AppState>,
    private router: Router,
    private relationshipCategoryFB: FormBuilder,
    private relationshipCategoryService: RelationshipCategoryService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    private layoutUtilsService: LayoutUtilsService,
    public stringUtils: StringUtilsService,
  ) {}

  ngOnInit() {
    this.createForm();
  }

  getTitle() {
    if (this.data.mode === 'CREATE') return 'New Category';
    return 'Update Category - ' + this.data._item.name;
  }

  ngOnDestroy() {
    this.cdr.detach();
    this.subscriptions.forEach((el) => {
      if (el.sub) {
        el.sub.unsubscribe();
      }
    });
  }

  createForm() {
    this.relationshipCategoryForm = this.relationshipCategoryFB.group({
      type: [
        this.data._item && this.data._item.entity_type ? this.data._item.entity_type : null,
        Validators.required,
      ],
      name: [
        this.data._item && this.data._item.name ? this.data._item.name : null,
        Validators.required,
      ],
    });
  }

  onSubmit() {
    this.hasFormErrors = false;
    const controls = this.relationshipCategoryForm.controls;
    if (this.relationshipCategoryForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.hasFormErrors = true;
      return;
    }
    if (this.data.mode === 'CREATE') {
      this.addRelationshipCategory(this.prepareRelationshipCategory());
      return;
    }
    this.updateRelationshipCategory(this.prepareRelationshipCategory());
  }

  prepareRelationshipCategory(): RelationshipCategory {
    const controls = this.relationshipCategoryForm.controls;
    const _relationshipCategory = new RelationshipCategory();
    _relationshipCategory.id = this.data._item && this.data._item.id ? this.data._item.id : null;
    _relationshipCategory.name = controls.name.value;
    _relationshipCategory.entity_type = controls.type.value;
    return _relationshipCategory;
  }

  addRelationshipCategory(_relationshipCategory) {
    this.relationshipCategoryService
      .createRelationshipCategory(_relationshipCategory)
      .subscribe(() => {
        this.layoutUtilsService.showActionNotification(
          'Relationship Category Added Successfully',
          MessageType.Update,
          3000,
          false,
          false,
        );
        this.dialogRef.close();
      });
  }

  updateRelationshipCategory(_relationshipCategory) {
    this.relationshipCategoryService
      .updateRelationshipCategory(_relationshipCategory)
      .subscribe(() => {
        this.layoutUtilsService.showActionNotification(
          'Relationship Category Updated Successfully',
          MessageType.Update,
          3000,
          false,
          false,
        );
        this.dialogRef.close();
      });
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.relationshipCategoryForm.controls[controlName];
    if (!control) {
      return false;
    }
    return control.hasError(validationType) && (control.dirty || control.touched);
  }

  close() {
    this.dialogRef.close();
  }
}
